import apiClient from "../helpers/apiClient";
import { CommunityMediaEnum } from "../pages/community/enums/CommunityMediaEnum";
import { handleApiError } from "../utils/handleApiError";


export const insertResource = async (commentId: number | string, file: File, title: string, resourceType: CommunityMediaEnum ) => {
    try {
        const formData = new FormData();

        formData.append("title", title);
        formData.append("resource_type", resourceType);
        formData.append("file", file);

        const { data } = await apiClient.post(`/community/comments/${commentId}/resources/`, formData, { headers: { "Content-Type": "multipart/form-data" } });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const deleteResources = async (id: number | string) => {
    try {
        const { data } = await apiClient.delete(`/community/admin/resources/${id}/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}


export const getResources = async (id: number | string) => {
    try {
        const { data } = await apiClient.get(`/community/discussions/${id}/resources/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const banForum = async (id: number | string, ban_type: 'temporary' | 'permanent', duration_days: number, reason: string) => {
    try {
        const { data } = await apiClient.post(`/community/discussions/${id}/moderate/`, { action: 'banned', ban_type, duration_days, reason });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const banUser = async (user_id: number | string, ban_type: 'temporary' | 'permanent', duration_days: number, reason: string) => {
    try {
        const { data } = await apiClient.post(`/community/users/${user_id}/ban/`, { ban_type, duration_days, reason });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const toggleReact = async (id: number | string, comment_id: number | string) => {
    try {
        const { data } = await apiClient.post(`/community/comments/${comment_id}/react/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const deleteComments = async (id: number | string) => {
    try {
        const { data } = await apiClient.delete(`/community/comments/${id}/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const addComments = async (id: number | string, content: string, parent: number | null) => {
    try {
        const { data } = await apiClient.post(`/community/discussions/${id}/comments/`, { content, parent });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const getComments = async (id: number | string) => {
    try {
        const { data } = await apiClient.get(`/community/discussions/${id}/comments/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const adminDiscussionDetails = async (id: number | string) => {
    try {
        const { data } = await apiClient.get(`/community/admin/discussions/${id}/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const adminApproveReview = async (id: number | string) => {
    try {
        const { data } = await apiClient.post(`/community/discussions/${id}/moderate/`, { action: 'approve' });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const adminDeclineReview = async (id: number | string, reason_id: number, note: string) => {
    try {
        const { data } = await apiClient.post(`/community/discussions/${id}/moderate/`, { action: 'reject', reason_id, note });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const declineReasons = async () => {
    try {
        const { data } = await apiClient.get(`/community/decline-reasons/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const toogleArchiveDiscuss = async (id: number) => {
    try {
        const { data } = await apiClient.post(`/community/discussions/${id}/toggle-archive/`);
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const getMyMastermindCircles = async (archived: boolean, limit?: number, offset?: number) => {
    try {
        let params: any = {
            archived
        }
        if (limit !== undefined) params.limit = limit;
        if (offset !== undefined) params.offset = offset;
        const { data } = await apiClient.get(`/community/discussions/my-circles/`, { params });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const getCommunityDiscussions = async (post_type?: 'forum' | 'circle', search?: string, status?: 'published' | 'draft', limit?: number, offset?: number) => {
    try {
        let params: any = {}
        if(post_type)
            params.post_type = post_type;
        if(search)
            params.search = search;
        if(status)
            params.status = status;
        if(limit !== undefined)
            params.limit = limit;
        if(offset !== undefined)
            params.offset = offset;
        
        const { data } = await apiClient.get(`/community/discussions/`, { params });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const getAdminDiscussions = async (post_type?: 'forum' | 'circle', search?: string, limit?: number, offset?: number) => {
    try {
        let params: any = {}
        if(post_type)
            params.post_type = post_type;
        if(search)
            params.search = search;
        if(limit !== undefined)
            params.limit = limit;
        if(offset !== undefined)
            params.offset = offset;
        
        const { data } = await apiClient.get(`/community/admin/discussions/`, { params });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const getInvites = async (search?: string) => {
    try {
        let params: any = {};
        if(search)
            params.search = search;
        
        const { data } = await apiClient.get(`/community/users/invite-search/`, { params });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const getCommunityDiscussion = async (id: string | number) => {
    try {
        const { data } = await apiClient.get(`/community/discussions/${id}/`);
        return data;
    } catch (error) {
        // 404 = post baneado/eliminado/no visible: la pagina redirige al listado
        // via el error del hook, no queremos disparar el modal generico encima.
        handleApiError(error, { onNotFound: () => {} });
        throw error;
    }
}


export const createOpenDiscussion = async (topic: string, description: string, tags: string[]) => {
    try {
        const { data } = await apiClient.post(`/community/discussions/open/`, { topic, description, tags });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}
export const createAdminOpenDiscussion = async (host_id: number, topic: string, description: string, tags: string[]) => {
    try {
        const { data } = await apiClient.post(`/community/admin/discussions/open/`, { host_id, topic, description, tags });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const updateOpenDiscussion = async (id: string, topic: string, description: string, tags: string[]) => {
    try {
        const { data } = await apiClient.put(`/community/discussions/${id}/`, { topic, description, tags });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const createMastermindCircle = async (topic: string, content: string, tags: string[], invites: number[], facilitator: number) => {
    try {
        const { data } = await apiClient.post(`/community/discussions/circle/`, { topic, content, tags, invites, facilitator });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const createAdminMastermindCircle = async (host_id: number, topic: string, content: string, tags: string[], invites: number[], facilitator: number) => {
    try {
        const { data } = await apiClient.post(`/community/admin/discussions/circle/`, { host_id, topic, content, tags, invites, facilitator });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const updateMastermindCircle = async (id: number | string, topic: string, content: string, tags: string[], invites: number[], facilitator?: number) => {
    try {
        const { data } = await apiClient.put(`/community/discussions/${id}/`, { topic, content, tags, invites, facilitator });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const getTags = async (search: string) => {    
    try {
        let params: any = {}
        if(search)
            params.search = search;
        const { data } = await apiClient.get(`/community/tags/`, { params });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

export const getFacilitator = async (role_code?: string, search?: string) => {    
    try {
        let params: any = {}
        if(role_code)
            params.role_code = role_code;
        if(search)
            params.search = search;
        const { data } = await apiClient.get(`/community/facilitators/candidates/`, { params });
        return data;
    } catch (error) {
        handleApiError(error, {});
        throw error;
    }
}

